import React from 'react'
import ViewAct from '../components/ViewAct/ViewAct'
import { ActRoute } from '../routes/ActRoute'
import { useQueryParams } from 'src/hooks'
import { LoadingSpinner } from '@sendoutcards/quantum-design-ui'
import ActSetup from '../components/ActSetup/ActSetup'
import { ActErrorRoute } from '../routes/ActError'
import { ActError } from '../components/ActError/ActError'
import { DefaultError, SuspenseBoundary } from 'src/chrome'

type ActProps = {
  route: ActRoute
}

const Act: React.FC<ActProps> = ({ route }) => {
  const { token } = useQueryParams()
  const loadScreenSyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100dvh',
  }

  if (route?.subroute?.path === ActErrorRoute.path) {
    const code = parseInt(route.subroute.code)
    const validCode = Number.isNaN(code) ? -1 : code
    return <ActError code={validCode} />
  }

  if (!route.subroute) {
    if (!token) {
      throw new Error('404 Not Found')
    }
    return (
      <SuspenseBoundary
        unresolved={
          <div style={{ ...loadScreenSyles }}>
            <LoadingSpinner size="large" />
          </div>
        }
        failure={DefaultError}
      >
        <ViewAct token={token} />
      </SuspenseBoundary>
    )
  }

  return <ActSetup route={route} cardId={route.subroute.cardId} />
}

export default Act
